import React from "react";
import defaultIconSettings from "./defaultIconSettings";

const MountainIcon = ({
    color = defaultIconSettings.color,
    size = defaultIconSettings.size,
    className = defaultIconSettings.className,
}) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 640 512"
            style={{ height: size, width: size }}
            className={className}
        >
            <path
                fill={color}
                d="M560 160c44.2 0 80-35.8 80-80S604.2 0 560 0s-80 35.8-80 80 35.8 80 80 80zM55.9 512h523c33.8 0 61.1-27.4 61.1-61.1 0-11.2-3.1-22.2-8.9-31.8l-132-216.3C495 196.1 487.8 192 480 192s-15 4.1-19.1 10.7l-48.2 79L286.8 81c-6.6-10.6-18.3-17-30.8-17s-24.1 6.4-30.8 17L8.6 426.4C3 435.3 0 445.6 0 456.1 0 487 25 512 55.9 512z"
            />
        </svg>
    );
};

export default MountainIcon;
